import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { clearArchivesList } from '../../../../store/archive/archiveSlice'

import cls from './monthLink.module.sass'

export interface MonthLinkProps {
    href: string
    label: string
}

const MonthLink = ({ href, label }: MonthLinkProps) => {
    const dispatch = useDispatch()
    const location = useLocation()
    const isChosen =
        location.pathname.includes(href) &&
        !location.pathname.split(href).pop().includes('0') &&
        !location.pathname.split(href).pop().includes('1') &&
        !location.pathname.split(href).pop().includes('2')

    const handleClearList = () => {
        dispatch(clearArchivesList())
    }
    return (
        <Link className={`${cls.link} ${isChosen ? cls['link__chosen'] : ''}`} to={href} onClick={handleClearList}>
            {label}
        </Link>
    )
}

export default MonthLink
